/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Davide Iadeluca, Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { slug } from '../../../common';
import Notification from 'flarum/forum/components/Notification';
import AchievementLevel from '../../../common/components/AchievementLevel';
const t = function () {
  return app.translator.trans(...arguments);
};
const prfx = `${slug}.forum.notifications`;
export default class AchievementReceivedNotification extends Notification {
  icon() {
    return '';
  }
  href() {
    return app.route('user.achievements', {
      username: app.session.user.slug()
    });
  }
  content() {
    const {
      notification
    } = this.attrs;
    return t(`${prfx}.achievement_unlocked_text`, {
      display_name: notification?.fromUser()?.displayName()
    });
  }
  excerpt() {
    // A deleted UserAchievement leaves the subject null.
    const subject = this.attrs.notification.subject();
    const level = typeof subject?.achievementLevel === 'function' ? subject.achievementLevel() : null;
    if (!level) {
      return null;
    }
    return m("div", null, m(AchievementLevel, {
      achievementLevel: level
    }));
  }
}
flarum.reg.add('glowingblue-gamilytics', 'forum/achievements/components/AchievementUnlockedNotification', AchievementReceivedNotification);